<template>
  <div class="card-wrap">
    <div class="xzt-mask-ctn" v-show="barcodeBig === true || qrcodeBig === true">
      <div v-show="barcodeBig === true">
        <svg class="card-barcode big" @click="barcodeBig = false" id="barcode2"></svg>
      </div>
      <div class="card-qrcode big" v-show="qrcodeBig === true" @click="qrcodeBig = false" id="qrcode2" ref="qrcode2"></div>
    </div>
    <div class="card-container">
      <div class="top-title">
        权益详情
      </div>
      <div class="body">
        <!--<span class="description">本券来自活动赠送</span>-->
        <div class="title-pre" v-if="!detail.title"></div>
        <div class="title" v-if="detail.title">{{detail.title}}</div>
        <!--<div class="code-ctn">-->
          <!--<svg class="card-barcode" v-show="barcodeBig === false" @click="barcodeBig = true" id="barcode"></svg>-->
          <!--<div class="card-qrcode" v-show="qrcodeBig === false" @click="qrcodeBig = true" id="qrcode" ref="qrcode"></div>-->
        <!--</div>-->
        <!--<div class="card-info-ctn" style="margin-top: 40px">-->
          <!--<div class="left">卡号： {{detail.card_no}}</div>-->
          <!--<div class="right" v-clipboard:copy="detail.card_no" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</div>-->
        <!--</div>-->
        <div class="card-info-ctn">
          <div class="left">激活码： {{detail.card_password}}</div>
          <div class="right" v-clipboard:copy="detail.card_password" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</div>
        </div>
        <div class="bottom-btn-ctn">
          <!--<div class="btn">我要分享</div> -->
          <div class="btn" v-if="detail.ticket_url"><a :href="detail.ticket_url">我要使用</a></div>
        </div>
        <!--<img class="right-arrow" src="../../../../assets/images/test-code.png"/>-->
        <!--<div class="subtitle">核销时请出示二维码给收银员</div>-->
        <!--<div class="sys-button" @click="markCode">标注已使用</div>-->
      </div>
    </div>
    <!--<div class="line"></div>-->
    <div class="bottom-container">
      <div class="bottom-ctn">
        <!--<div  @click="$router.push('/user/card/card/store?id=' + detail.id)">适用门店-->
          <!--<span style="color: #9B9B9B">-->
            <!--&lt;!&ndash;共{{detail.store_num}}家门店&ndash;&gt;-->
            <!--<img class="right-arrow" src="../../../../assets/images/arrow-right-black.png"/>-->
          <!--</span>-->
        <!--</div>-->
        <div @click="$router.push('/user/card/card/detail?id=' + $route.query.id)">有效期
          <span>
            {{detail.expire_time}}
          </span>
        </div>
        <div style="border: none">使用说明
        </div>
        <div style="border: none;height: 15px;padding-bottom: 2vw;line-height: 15px">
          1, 下载阿拉订APP后，请用手机号进行注册
        </div>
        <div style="border: none;height: 15px;padding-bottom: 2vw;line-height: 15px">
          2, APP首页选择「激活码」进行兑换并使用
        </div>
        <div style="border: none;height: 15px;padding-bottom: 2vw;line-height: 15px">
         3, 本服务权益不兑换现金，不找零，不记名，不挂失
        </div>
        <div style="border: none;height: 15px;padding-bottom: 2vw;line-height: 15px">
          4, 请在有效期内使用，逾期作废
        </div>
        <div style="border: none;height: 15px;padding-bottom: 2vw;line-height: 15px" v-if="detail.title == '洗车2次'">
          5, 此券仅限兑换洗车服务
        </div>
        <div style="border: none;padding-bottom: 2vw;">
          <div style="display: inline-block;padding: 0">客服热线：400-888-5811</div>
          <div @click="$router.push('/user/card/card/wendang')" style="display: inline-block;float: right;font-weight: bold">操作指南</div>
        </div>
        <div style="border: none;height:155px;padding-bottom: 2vw;text-align: center">
          <img style="height: 80px;width: 80px" src="../../../../assets/images/dabaojia-qrcode.png"/>
          <div style="border: none;padding-bottom: 2vw;">扫码下载APP</div>
        </div>

        <!--<div @click="toGZH">公众号-->
          <!--<span>-->
            <!--<img class="right-arrow" src="../../../../assets/images/arrow-right-black.png"/>-->
          <!--</span>-->
        <!--</div>-->
      </div>
    </div>
    <!--<div class="code-big-bg" v-if="barcodeBig === true || qrcodeBig === true"></div>-->
    <div class="bottom-description">如核销失败，将尝试其他付款方式</div>
  </div>
</template>

<script>
  import { Toast,MessageBox } from 'mint-ui'
  import wx from 'weixin-js-sdk'
  import QRCode  from 'qrcodejs2'
  import JsBarcode from 'jsbarcode'
export default {
  computed: {
  },
  components: {
    QRCode,
    [MessageBox.name]:MessageBox,
    [Toast.name]:Toast
  },
  data () {
    return {
      showXZT: false,
      barcodeBig: false,
      qrcodeBig: false,
      detail: {},

      // detail: {
      //   title: '阿拉丁汽车服务包100元',
      //   expire_time:'2018.05.02-2019.05.20',
      //   id: 2,
      //   store_num: 2,
      //   describe: '凭此券可到指定商店享受满减活动1次，优惠金额上限为75元，不与其他优惠同享。',
      //   card_no: 'a0000001',
      //   card_password: '123456'
      // },

      wechat_js: {}
    }
  },
  watch: {
  },
  mounted () {
    this.pageInit()
    // this.getDetail()
    /*
    JsBarcode('#barcode', '1817403155011499', {
      lineColor: "#000000",
      width: 1.5,
      height: 40
    })
    JsBarcode('#barcode2', '1817403155011499', {
      lineColor: "#000000",
      width: 1.5,
      height: 40
    })
    let qrcode = new QRCode('qrcode', {
      text: '1817403155011499'
    })
    let qrcode2 = new QRCode('qrcode2', {
      text: '1817403155011499'
    })
    */
  },
  methods: {
    pageInit () {
      this.getDetail()
    },
    // 复制成功
    onCopy(e){
      console.log(e)
      Toast('复制成功')
    },
    // 复制失败
    onError(e){
      Toast('复制失败')
    },
    markCode  () {
      MessageBox({
        title: '',
        confirmButtonText: '确认',
        message: '本卡券将从未使用状态改为已使用状态，同时注销券码，本操作不可逆，请再次确认操作！',
        showCancelButton: true
      }).then(action => {
        console.log(action)
      })
    },
    toGZH () {
      window.location.href = 'https://mp.weixin.qq.com/mp/profile_extaction=home&__biz=MzU3MzQ5MDY5Nw==#wechat_redirect'
    },
    showCode () {
      JsBarcode('#barcode', this.detail.card_password, {
        lineColor: "#000000",
        width: 1.5,
        height: 40
      })
      JsBarcode('#barcode2', this.detail.card_password, {
        lineColor: "#000000",
        width: 1.5,
        height: 40
      })
      let qrcode = new QRCode('qrcode', {
        text: this.detail.card_password
      })
      let qrcode2 = new QRCode('qrcode2', {
        text: this.detail.card_password
      })
    },
    getDetail () {
      let params = {}
      params.id = this.$route.query.id
      params.h5_target_url = window.location.href
      this.$api.user.getCouponDetails(params).then((res) => {
        console.log(res.data)
        if (res.data.code == 1) {
          this.detail = res.data.data
          this.showCode()
          // this.detail = res.data.data.coupon
          // this.wechat_js = res.data.data.wechat_js
          // wx.config(this.wechat_js)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    scanQrCode () {
      var _this = this
      wx.ready(function () {
        wx.scanQRCode({
          needResult: 1,
          desc: 'scanQRCode desc',
          success: function (res) {
            var result = res.resultStr.split('/q/')
            var q = result[1]
            window.location.href='/index/trade/pay_page?q=' + q + '&cid=' + _this.detail.id
          }
        })
      })
    },
    showHowToUse () {
      this.showXZT = true
    },
    closeHowToUse () {
      this.showXZT = false
    }
  }
};
</script>

<style lang="scss">
  @import "@/assets/css/my-mint.scss";
  /*.code-big-bg {*/
    /*z-index: 100;*/
    /*position: absolute;*/
    /*top: 0;*/
    /*width: 100%;*/
    /*height: 100%;*/
    /*background-color: #fff;*/
  /*}*/
  .card-info-ctn {
    clear: both;
    height: 80px;
    padding: 0 50px;
    line-height: 40px;
    color: #4a4a4a;
    font-size: 26px;
    .left,.right {
      display: inline-block;
      vertical-align: middle;
    }
    .left {
      float: left;
      position: relative;
      top:5px;
    }
    .right {
      float: right;
      background-color: #f5f5f5;
      border: #a5a5a5 .5px solid;
      border-radius: 15px;
      padding: 5px 20px;
    }
  }
  .bottom-btn-ctn {
    .btn {
      display: inline-block;
      background-color: #0158a3;
      color: #fff;
      padding: 10px 35px;
      margin: 0 30px;
    }
    a {
      color: #fff;
    }
  }
  .mint-msgbox {
    width: 60% !important;
    .mint-msgbox-content {
      padding: 25px 40px;
      font-size: 25px;
      line-height: 40px;
      .mint-msgbox-message {
        color: #000;
      }
    }
    .mint-msgbox-btns {
      line-height: 80px;
      height: 80px;
      .mint-msgbox-cancel {
        font-size: 30px;
        color: #999999;
      }
      .mint-msgbox-confirm {
        font-size: 30px;
        color: #000;
        font-weight: bold;
      }
    }
  }
  .xzt-mask-ctn {
    position: fixed;
    height: 100%;
    width: 100%;
    background: #fff;
    z-index: 1000;
    color: #000;
    text-align: center;
    div {
      img {
        width: 270px;
        height: 270px;
        border: solid 2px #fff;
        border-radius: 10px;
        margin-top: 30%;
        margin-bottom: 10%;
      }
    }
    .title {
      color: #FFDA00;
      font-size: 30px;
      padding-bottom: 30px;
    }
    .description {
      font-size: 25px;
      font-weight: 100;
    }
    .close-btn {
      width: 100px;
      margin: 70px auto;
      padding: 10px 30px;
      color: #FFDA00;
      font-size: 30px;
      border: 1px solid #FFDA00;
      border-radius: 5px;
    }
  }
  .code-ctn, .xzt-mask-ctn {
    text-align: center;
    .card-qrcode {
      width: 180px;
      height: 180px;
      margin:20px auto;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .card-qrcode.big {
      transform: scale(2) !important;
      margin-top: 50%;
    }
    .card-barcode {
      margin-top: 20px;
    }
    .card-barcode.big {
      transform: rotate(90deg) scale(2) !important;
      transform-origin: -5% 115% !important;
    }
  }
  .card-wrap {
    background-color: #f0f0f0;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: -100;
    padding-bottom: 300px;
  }
  .card-container {
    margin: 0 40px;
    margin-top: 40px;
    position: relative;
    .top-title {
      background: url("../../../../assets/images/top-bg2.png");
      background-size:100% 100%;
      height: 80px;
      width:100%;
      text-align: center;
      line-height: 80px;
      font-size: 30px;
      color: #fff;
    }
    .body {
      text-align: center;
      padding: 60px 40px;
      padding-bottom: 20px;
      font-size: 22px;
      .title, .title-pre {
        color: #4A4A4A;
        font-size: 45px;
        font-weight: bold;
      }
      .title-pre {
        height: 50px;
        width: 10px;
      }
      .subtitle {
        color: #9B9B9B;
        font-size: 24px;
        margin: 0 auto;
        margin-top: 40px;
      }
      .description {
        color: #fff;
        font-size: 20px;
        background: #DCDCDC;
        border-radius: 5px;
        padding: 10px 20px;
        margin: 0 auto;
      }
      .sys-button {
        color: #fff;
        width: 150px;
        margin: 0 auto;
        margin-top: 30px;
        font-size: 30px;
        padding: 15px 20px;
        background: #4b4b4b;
      }
    }
    .body::before {
      content: '';
      position: absolute;
      top: 80px;
      left: 0;
      right:0;
      z-index: -1;
      height:100%;
      width: 50%;
      background:radial-gradient(40px at left bottom,transparent 50%,#fff 50%);
    }
    .body::after {
      content: '';
      position: absolute;
      top: 80px;
      left: 50%;
      right:0;
      z-index: -1;
      height:100%;
      width: 50%;
      background:radial-gradient(40px at right bottom,transparent 50%,#fff 50%);
    }
  }


  .line {
    margin: 0 65px;
    position: relative;
    border-top: 1px solid #E5E5E5;
    top: 80px;

  }
  .bottom-container {
    position: relative;
    margin: 0 40px;
    margin-top: 75px;
  }
  .bottom-ctn {
    border-top: 1px solid #E5E5E5;
    margin: 0 20px;
    color: #4A4A4A;
    font-size: 25px;
    div{
      line-height: 90px;
      height: 90px;
      border-bottom: 2px dashed #E5E5E5;
      padding: 0 20px;
      span {
        float: right;
        .right-arrow {
          width: 35px;
          height: 35px;
          position: relative;
          top: 30px;
          opacity: 0.3
        }
      }
    }
  }
  .bottom-ctn::before {
    content: '';
    position: absolute;
    top: 0px;
    left: 0;
    right:0;
    z-index: -1;
    height:100%;
    width: 50%;
    background:radial-gradient(40px at left top,transparent 50%, #fff 50%);
  }
  .bottom-ctn::after {
    content: '';
    position: absolute;
    top: 0px;
    left: 50%;
    right:0;
    z-index: -1;
    height:100%;
    width: 50%;
    background:radial-gradient(40px at right top,transparent 50%,#fff 50%);
  }


  .bottom-description {
    margin-top: 50px;
    text-align: center;
    font-size: 22px;
    color: #c0c4cc;
  }
</style>
